import { useAppDispatch, useAppSelector } from '@redux/store';
import { FC, useCallback } from 'react';

import { List } from '@3.0/List';
import DataSourceListItem from './DataSourceListItem';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import DataSourcesMenuBar from './components/DataSourcesMenuBar';
import { setTableSearchTerm } from './redux/IngestionDataSourceList.slice';
import { IOnAddDismissibleLinkProp } from '../../constants/ingestion.constants';
import TableList from './TableList';

const TableListHOC: FC<IOnAddDismissibleLinkProp> = ({ onAddDismissibleLink }) => {
  const dispatch = useAppDispatch();
  const selectedDataSource = useAppSelector(
    (state) => state.ingestionDataSourceList.selectedDataSource
  );

  const setSearchTerm = useCallback(
    (term: string) => {
      dispatch(setTableSearchTerm({ searchTerm: term }));
    },
    [dispatch]
  );

  return (
    <section>
      <List>
        <>
          <DataSourceListItem
            listItem={selectedDataSource as IDataSourceItem}
            showLogButton
            onAddDismissibleLink={onAddDismissibleLink}
            mode="TableViewDataSource"
          />
          <li>
            <DataSourcesMenuBar setSearchTerm={setSearchTerm} />
          </li>
        </>
      </List>

      <TableList />
    </section>
  );
};

export default TableListHOC;
